import { useCallback } from 'react';
import { useNavigationManager } from '@provider/navigation';
import { useCurrentPage } from '../state/hook.current-page.js';
import { iArkStore } from '../state/store.js';

function useIArkNavigation() {
  const entryKey = iArkStore.useSelector(state => state.entryKey);
  const component = iArkStore.useSelector(state => state.component);
  const navigation = useNavigationManager();
  const {
    index
  } = useCurrentPage(component.data, entryKey);
  const canGoBackwards = index > 0;
  const handleGoBackwards = useCallback(() => {
    const previousPageId = component.data.pages[index - 1]?.id;
    if (!previousPageId) {
      return;
    }
    navigation.push(`${previousPageId}${window.location.search}`);
  }, [index, navigation, component.data.pages]);
  const canGoForwards = index < component.data.pages.length - 1;
  const handleGoForwards = useCallback(() => {
    const nextPageId = component.data.pages[index + 1]?.id;
    if (!nextPageId) {
      return;
    }
    navigation.push(`${nextPageId}${window.location.search}`);
  }, [index, navigation, component.data.pages]);
  return {
    canGoBackwards,
    handleGoBackwards,
    canGoForwards,
    handleGoForwards
  };
}

export { useIArkNavigation };
//# sourceMappingURL=hook.navigation.js.map
